<template>
  <div>
    <div class="page-content">
      <div class="container-fluid background">
        <div class="row">
          <img src="~@/assets/images/brick-wall.jpg" alt="Brick image" class="col-12 p-0">
        </div>
      </div>
      <div class="container content">
        <div class="row">
          <div class="col-12">
            <h1 class="page-header">
              Portfolio
              <hr />
            </h1>
          </div>
          <!-- <div class="col-12">
            <p>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur
            </p>
          </div> -->
        </div>
       </div>
    </div>

    <div id="image-portfolio" class="image-portfolio">
      <div class="container">
        <div class="row">
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/17dd824c_8ebc_428c_b6e5_3a87c1b0fd02.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/351328d9_001a_40d4_80a6_f433cb2d09ad.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0344.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0346.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0430.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0431.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0432.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0434.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0437.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0588.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0685.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0706.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0707.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0715.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0716.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0717.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0723.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0724.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0725.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0728.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0759.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_0760.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_2288.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_2289.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/img_2541.jpg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0905.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0908.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0907.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0906.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0909.jpeg"
              alt="Construction Project"
            />
          </div>

          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0895.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0903.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0897.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0898.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/IMG_0899.jpeg"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/brick-well-2026.webp"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/front-garden-wall-2026.webp"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/garden-steps-2026.webp"
              alt="Construction Project"
            />
          </div>
          <div class="image-card col-md-6 mb-4">
            <img
              class="image-card-img"
              src="~@/assets/images/portfolio/garden-wall-2026.webp"
              alt="Construction Project"
            />
          </div>
        </div>
      </div>
    </div>



    <div id="cta-banner" class="cta-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-xl-3 cta-banner-wrapper">
            <h2 class="cta-banner-title">
              Get In Touch
            </h2>
          </div>
          <div class="col-lg-8 col-xl-6 cta-banner-wrapper">
            <p class="cta-banner-content">
              For your free no obligation quote, get in touch today
            </p>
          </div>
          <div class="col-lg-4 col-xl-3 cta-banner-wrapper">
            <router-link to="/contact-us/" class="mt-4 mt-lg-0 btn cta-banner-btn">
              Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portfolio'
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.background {
  margin-top: -64px;
  width: 100%;
  height: 430px;
  border-bottom: 3px solid $primary;

  @media screen and (max-width: $md-breakpoint) {
    height:  300px;
  }

  .row {
    height: 100%;
  }
  .row img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

/****************************
    CONTENT
*****************************/
.content {
  margin-top: 64px;
}

/****************************
    IMAGE PORTFOLIO
*****************************/

.image-portfolio {
  padding: 64px 0;
  background-color: $secondary;
  .gap {
    row-gap: 30px;
  }
  .image-card {
    &-img {
      height: 400px;
      width: 100%;
      object-fit: cover;
      border-radius: 10px 10px 10px 10px;
    }
    .card-1-content {
      @media (min-width: $sm-md-breakpoint) {
        height: auto;
        margin-top: 0 !important;
      }
      @media (min-width: $md-breakpoint) {
        height: 304px;
        margin-top: 0 !important;

      }
      @media (min-width: $lg-breakpoint) {
        height: 280px;
      }
    }
  }
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;
    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Portfolio.vue